import {
  markCurrentAccountStorageBootstrapPushPending,
  readAccountScopedStorage,
  removeAccountScopedStorage,
  writeAccountScopedStorage,
} from "@/shared/storage/account-scope";
import {
  CONTENT_PUSH_INTENT_KEYS,
  acknowledgeContentPushIntentSync,
  markContentPushIntentSync,
  pendingContentPushOptions,
  readContentPushIntent,
  type ContentPushIntentDomain,
  type ContentPushIntentReceipt,
  type ContentPushOptions,
} from "./content-push-intent-state.mjs";

export { CONTENT_PUSH_INTENT_KEYS };
export type { ContentPushIntentReceipt };

const currentAccountIntentIo = {
  read: (domain: ContentPushIntentDomain) =>
    readAccountScopedStorage(CONTENT_PUSH_INTENT_KEYS[domain]),
  write: (domain: ContentPushIntentDomain, value: string) =>
    writeAccountScopedStorage(CONTENT_PUSH_INTENT_KEYS[domain], value),
  remove: (domain: ContentPushIntentDomain) =>
    removeAccountScopedStorage(CONTENT_PUSH_INTENT_KEYS[domain]),
};

export function readCurrentContentPushIntent(): ContentPushIntentReceipt {
  return readContentPushIntent(currentAccountIntentIo);
}

export function journalCurrentContentPushIntentSync(
  options: ContentPushOptions,
): ContentPushIntentReceipt {
  const intent = markContentPushIntentSync(currentAccountIntentIo, options);
  // A frozen new-account bootstrap request cannot absorb an edit made after
  // it was journaled. Persist the same domain in the bootstrap late-edit
  // ledger in this call stack, before the store emits its change event.
  markCurrentAccountStorageBootstrapPushPending(options);
  return intent;
}

export function pendingCurrentContentPushOptions(): ContentPushOptions {
  return pendingContentPushOptions(currentAccountIntentIo);
}

export function acknowledgeCurrentContentPushIntentSync(
  receipt: ContentPushIntentReceipt,
  pushedOptions: ContentPushOptions,
): ContentPushIntentReceipt {
  return acknowledgeContentPushIntentSync(
    currentAccountIntentIo,
    receipt,
    pushedOptions,
  );
}
